import type { Churn, ChurnLevel, KpiBand } from '@/types/clientKpis'

export const BAND_CLASSES: Record<KpiBand, string> = {
  green: 'bg-emerald-600 text-white',
  blue: 'bg-blue-600 text-white',
  orange: 'bg-orange-500 text-white',
  red: 'bg-red-600 text-white',
  black: 'bg-etn-text text-white',
}

export const BAND_DOT: Record<KpiBand, string> = {
  green: 'bg-emerald-600',
  blue: 'bg-blue-600',
  orange: 'bg-orange-500',
  red: 'bg-red-600',
  black: 'bg-etn-text',
}

export const BAND_NAMES: Record<KpiBand, string> = { green: 'Green', blue: 'Blue', orange: 'Orange', red: 'Red', black: 'Black' }

export const CHURN_CLASSES: Record<ChurnLevel, string> = {
  Low: 'bg-emerald-600 text-white',
  Medium: 'bg-orange-500 text-white',
  High: 'bg-red-600 text-white',
  Critical: 'bg-etn-text text-white',
}

export const CHURN_ACTIONS: Record<ChurnLevel, string> = {
  Low: 'Normal cadence, review at the quarterly check-in.',
  Medium: 'Account owner fixes the weakest KPI within 30 days.',
  High: 'Recovery plan agreed with the client; start the renewal conversation early.',
  Critical: 'Escalate to Ben; senior meeting with the client within 2 weeks.',
}

export function churnTitle(churn: Pick<Churn, 'level' | 'raisedFrom' | 'fell' | 'noRenewalDate' | 'fallingMonths'>): string {
  if (!churn.level) return ''
  const months = churn.fallingMonths ?? 3
  const raised = churn.raisedFrom
    ? churn.fell != null
      ? `Raised from ${churn.raisedFrom}: the score fell ${churn.fell} points in ${months} months.`
      : `Raised from ${churn.raisedFrom}: the score fell in the last ${months} months.`
    : null
  return [CHURN_ACTIONS[churn.level], raised, churn.noRenewalDate ? 'No renewal date: risk may be higher.' : null].filter(Boolean).join(' ')
}
